// Phase 8 — DD/MM/YYYY date formatting shared across the app.
export function formatDate(iso, opts = {}) {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  if (isNaN(d.getTime())) return String(iso);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  if (!opts.includeTime) return `${dd}/${mm}/${yyyy}`;
  const hh = String(d.getHours()).padStart(2, "0");
  const mn = String(d.getMinutes()).padStart(2, "0");
  return `${dd}/${mm}/${yyyy} ${hh}:${mn} IST`;
}

export const EMERGENCY_TOGGLE_ALLOWED = new Set([
  "cao@mitgurukul.com",
  "jahnavi.m@mitgurukul.com",
]);

export const canToggleEmergency = (u) =>
  !!u && EMERGENCY_TOGGLE_ALLOWED.has((u.email || "").toLowerCase());
